export default __webpack_public_path__ + "static/media/IMG_9488.3d7dc03c.PNG";